import { render, staticRenderFns } from "./MonthlyTaxAffin.vue?vue&type=template&id=7dab1507"
import script from "./MonthlyTaxAffin.vue?vue&type=script&lang=js"
export * from "./MonthlyTaxAffin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports